(function () {
  //ハンバーガー
	document.addEventListener ('DOMContentLoaded', function () {
		document.getElementById ('menu-button').addEventListener ('click', function () {
			this.classList.toggle ('active');
			document.getElementById ('nav').classList.toggle ('active');
		});
		if(document.getElementById ('nav')) {
			document.getElementById ('nav').addEventListener ('click', function () {
			this.classList.remove ('active');
			document.getElementById ('menu-button').classList.remove ('active');
			});
		}
	});

	// スクロール
	const targetElement = document.querySelectorAll(".fade");
	document.addEventListener("scroll", function(){
		for (let i = 0; i < targetElement.length; i++) {
			const getElementDistance = targetElement[i].getBoundingClientRect().top + targetElement[i].clientHeight *.2
			if (window.innerHeight > getElementDistance) {
				targetElement[i].classList.add("show");
			}
		}
	})
}) ();